import React from "react";
import { useMsal } from "@azure/msal-react";
import styles from "../Login/styles.module.css";

export const Unauthorized = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginWrapper}>
        <h1>Access Denied</h1>
        <p>
          Your account is not authorized to use this application. Please contact
          your administrator to request access.
        </p>
        <button onClick={handleLogout}>Sign out</button>
      </div>
    </div>
  );
};
